import { useEffect, useState } from "react";

import { fetchOtMe } from "../api/otApi";

/**
 * Whether the calling user may record a PAC clearance, per GET /ot/me/
 * (main/ot/sql/036_ot_anaesthetist.sql).
 *
 * Replaces reading the ot_pac permission out of PermissionContext: that
 * permission stopped meaning "anaesthetist" once clearance moved to an
 * OT-owned roster instead of a role/permission (roleType doubles as user
 * identity in this app, so the role-based gate broke the doctor console for
 * anyone moved onto it -- see 036's SQL header).
 *
 * Defaults to `false` while the request is in flight and on any failure --
 * an unresolved caller must not be treated as an anaesthetist.
 */
export function useIsAnaesthetist() {
  const [isAnaesthetist, setIsAnaesthetist] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchOtMe()
      .then((data) => {
        if (!cancelled) setIsAnaesthetist(!!data?.is_anaesthetist);
      })
      .catch(() => {
        if (!cancelled) setIsAnaesthetist(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { isAnaesthetist, loading };
}
